// extracted by extract-css-chunks-webpack-plugin
module.exports = {"recurring-gift-line":"gift-description__recurring-gift-line___2pPtC","recurringGiftLine":"gift-description__recurring-gift-line___2pPtC","currency-code":"gift-description__currency-code___2divp","currencyCode":"gift-description__currency-code___2divp","amount":"gift-description__amount___3fC16"};
    if(module.hot) {
      // 1747693939070
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  